import React from 'react';
import { SvgStyled } from 'components/common/Icon/Icon.styles';

export default () => (
  <SvgStyled xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <rect x="16" y="-6" width="8" height="8" transform="rotate(45)" />
  </SvgStyled>
);
